import { UserTask } from 'models/UserTask';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const UserTaskActionType = {
    FETCH_USERTASKS: 'FETCH_USERTASKS',
    FETCH_USERTASKS_SUCCESS: 'FETCH_USERTASKS_SUCCESS',
    ADD_USERTASK: 'ADD_USERTASK',
    ADD_USERTASK_SUCCESS: 'ADD_USERTASK_SUCCESS',
    EDIT_USERTASK: 'EDIT_USERTASK',
    EDIT_USERTASK_SUCCESS: 'EDIT_USERTASK_SUCCESS',
    DELETE_USERTASK: 'DELETE_USERTASK',
    DELETE_USERTASK_SUCCESS: 'DELETE_USERTASK_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchUserTasksAction {
    type: typeof UserTaskActionType.FETCH_USERTASKS
    payload: ApiPayload,
    returnPayload: UserTask[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddUserTasksAction {
    type: typeof UserTaskActionType.ADD_USERTASK
    payload: ApiPayload,
    returnPayload: UserTask,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteUserTasksAction {
    type: typeof UserTaskActionType.DELETE_USERTASK
    payload: ApiPayload,
    returnPayload: UserTask,
    meta: {
        isApiCall: boolean
    },
}

export type IUserTaskActions = IFetchUserTasksAction | IAddUserTasksAction | IDeleteUserTasksAction

const baseUrl = 'api/userTasks';
export class UserTaskActions {
    public static fetchUserTasks(token: string): IUserTaskActions {
        return {
            type: UserTaskActionType.FETCH_USERTASKS,
            payload: Api.fetchApiCall(baseUrl, token, UserTaskActionType.FETCH_USERTASKS_SUCCESS, UserTaskActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addUserTask(token: string, userTask: UserTask): IUserTaskActions {
        return {
            type: UserTaskActionType.ADD_USERTASK,
            payload: Api.postApiCall(baseUrl, token, UserTaskActionType.ADD_USERTASK_SUCCESS, UserTaskActionType.API_ERROR, userTask, true),
            returnPayload: UserTask.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteUserTask(token: string, id: number): IUserTaskActions {
        return {
            type: UserTaskActionType.DELETE_USERTASK,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, UserTaskActionType.DELETE_USERTASK_SUCCESS, UserTaskActionType.API_ERROR, true),
            returnPayload: UserTask.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}
